<template>
  <v-container
    fluid
    class="ma-0 pa-0"
  >
    <div id="content-body"
      :style="{ backgroundColor: content.backgroundColor }"
    >
      <v-row
        no-gutters
        align="center"
        justify="center"
      >
        <div class="content-title">
          <h1>
            {{ content.title }}
            <span style="color:#F5A21E">리치고</span>
            <br>
            지금 경험해보세요
          </h1>
        </div>
        <v-dialog
          v-model="dialog"
          persistent
          width=1804
        >
          <template v-slot:activator="{ on }">
            <img
              v-if="content.title === '부동산'"
              class="tryTableauButton"
              v-on="on"
              @click="onDialog"
              :src="tryTableauImg"
            />
          </template>

          <v-card
          >
            <v-toolbar
              dark
              color="primary"
              dense
              min-width=1804
            >
              <v-btn
                icon
                dark
                @click="dialog = false"
              >
                <v-icon
                  v-show="dialogCloseButton"
                >mdi-close</v-icon>
              </v-btn>
              <div style="width:300px;">
                <v-card-text
                  v-if="!dialogCloseButton"
                >
                  잠시만 기다려주세요
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mt-1"
                  ></v-progress-linear>
                </v-card-text>
              </div>

            </v-toolbar>

            <div class="tableauEmbedded">
              <iframe src="https://public.tableau.com/views/__last_/province_priceIndex_flowchart?:embed=y&:display_count=yes&publish=yes&:origin=viz_share_link&:showVizHome=no" class="iframe" width="1804" height="1031" />
            </div>

          </v-card>
        </v-dialog>
      </v-row>
      <v-row
        no-gutters
        align="center"
        justify="center"
      >
        <v-tabs
          :background-color="content.backgroundColor"
          color="gray"
          centered
          show-arrows
          v-model="tab"
          class="mt-3"
        >
          <v-tab
            v-for="(item, index) in content.items"
            :key="item.title"
            :href="item.href"
            @click="onClickTab(item.title, index)"
          >{{ item.title }}</v-tab>
        </v-tabs>
      </v-row>

      <v-row
        no-gutters
        align="center"
        justify="center"
      >
        <v-tabs-items
          v-model="tab"
        >
          <v-tab-item
            v-for="item in content.items"
            :key="item.title"
            :value="item.title"
            style="margin:0 auto"
          >
            <div
              class="image-wrapper"
              :style="{backgroundColor: content.backgroundColor}"
            >
              <img
                :src="backgroundImage"
                class="background-img"
                :style="{backgroundColor: content.backgroundColor}"
              >
              <div class="inner-image-wrapper">
                <img
                  :src="item.img"
                  class="inner-img"
                >
                <div class="content-desc">
                  {{ item.desc }}
                </div>
              </div>
            </div>
            <div style="position:relative">
              <p
                class="warning-text"
              >
                ※ 상기 이미지는  이해를 돕기 위해 실제 구동되는 ‘{{ content.title }} 리치고’ 서비스를 바탕으로 제작된 화면이며 결제 후 서비스는 차이가 있을 수 있습니다.
                <br>
                ※ 서비스 소개는 2019년 3월 데이터를 기반으로 작성 되었으며, 매주 업데이트 되는 최신 차트 및 데이터는 결제 후 확인이 가능합니다.
                <br>
                ※ 투자의 최종적인 책임은 투자자 본인에게 있습니다.
              </p>
            </div>

          </v-tab-item>
        </v-tabs-items>
      </v-row>
      <v-row
        no-gutters
        align="center"
        justify="center"
      >
        <p class="bottom-comment">
          {{ content.bottomComment }}
        </p>
      </v-row>
    </div>

  </v-container>
</template>

<script>
export default {
  props: [
    'content'
  ],
  data() {
    return {
      dialog: false,
      dialogCloseButton: false,
      tryTableauImg: require('../../assets/service/tryTableau.png'),
      backgroundImage: require('../../assets/service/desktop.png'),
      tab: null,
    }
  },
  methods: {
    onDialog() {
      this.$ga.event('서비스 소개', `${this.content.title} 리치고 체험 클릭`, '부동산 리치고 체험');

      if (this.dialogCloseButton === false) {
        setTimeout(() => {
          this.dialogCloseButton = true;
        }, 5000);
      }
    },
    onClickTab(contentTitle, tabIndex) {
      this.$ga.event('서비스 소개', `${this.content.title} 리치고 소개 클릭`, contentTitle, tabIndex);
    }
  }
}
</script>

<style scoped>
#content-body {
  padding-top: 50px;
}

.content-title h1 {
  text-align: center;
  font-weight: 400;
  font-size: 44px;
  color: #454f5d;
}

.background-img {
  width: 1000px;
}

.inner-img {
  width: 885px;
  position: absolute;
  top: 60px;
  left: 55px;
  margin: 0 auto;
  height:506px;
}

.warning-text {
  padding: 0;
  margin: 0;
  font-size: 12px;
  position: absolute;
  top: -273px;
  left: 36px;
  width: 927px;
}

.bottom-comment {
  font-weight: 200;
  font-size: 13px;
  color: #454f5d;
  margin-bottom: 30px;
}

.content-desc {
  background: #F5A21E;
  position: absolute;
  width: 879px;
  height: 58px;
  top: 509px;
  left: 57px;
  font-size: 28px;
  padding: 9px;
  color: #ffffff;
  text-align: center;
}

.tryTableauButton {
  position: absolute;
  width: 187px;
  top: 271px;
  right: calc(50% - 665px);
  z-index: 1;
}

.tryTableauButton:hover {
  cursor: pointer;
}


@media only screen and (max-width:600px) {
  .content-title h1 {
    font-size: 36px;
  }

  .background-img {
    width: 300px;
    margin-top: 15px;
  }
  .inner-img {
    margin-top: 15px;
    width: 264px;
    height: 155px;
    left: -82px;
    top: -267px;
  }
  .bottom-comment {
    padding:10px;
    margin: 0;
    font-size: 14px;
    text-align: center;
    background-color: #fafafa;
  }

  .warning-text {
    margin: 0;
    padding-top: 20px;
    position: static;
    top:0;
    left:0;
    width: auto;
    text-align: center;
    background-color: #fafafa;
  }

  .image-wrapper {
    position: relative;
    text-align: center;
  }

  .inner-image-wrapper {
    position: relative;
    width: 100px;
    margin: 0 auto;
  }

  .content-desc {
    width: 287px;
    height: 30px;
    top: -127px;
    left: -94px;
    font-size: 8px;
    z-index: 1;

    padding-left: 2px;
    padding-right: 2px;
    padding-top: 8px;
  }

  .tryTableauButton {
    position: absolute;
    width: 100px;
    top: 220px;
    right: calc(50% - 158px);
    z-index: 1;
  }
}
</style>
